if (!customElements.get('cart-upsell-card')) {
  customElements.define(
    'cart-upsell-card',
    class CartUpsellCard extends HTMLElement {
      constructor() {
        super();
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        this.select = this.querySelector('select[name="id"]');
        this.priceWrapper = this.querySelector('[data-cart-upsell-price]');
        this.submitButton = this.querySelector('[name="add"]');

        if (!this.select) return;
        this.select.addEventListener('change', this.onVariantChange);
      }

      disconnectedCallback() {
        this.select && this.select.removeEventListener('change', this.onVariantChange);
      }

      onVariantChange() {
        const option = this.select.options[this.select.selectedIndex];
        if (!option) return;

        this.updateButton(option);
        this.updatePrice(option);
      }

      updateButton(option) {
        if (!this.submitButton) return;

        const unavailable = option.hasAttribute('disabled');
        const label = this.submitButton.querySelector('.btn__text');

        this.submitButton.toggleAttribute('disabled', unavailable);
        if (label) {
          label.textContent = unavailable
            ? FoxTheme.variantStrings.soldOut
            : FoxTheme.variantStrings.addToCartShort;
        }
      }

      updatePrice(option) {
        if (!this.priceWrapper) return;

        const price = Number(option.dataset.price);
        if (Number.isNaN(price)) return;

        const compareAtPrice = Number(option.dataset.compareAtPrice) || 0;
        const onSale = compareAtPrice > price;
        const format = FoxTheme.settings.moneyFormat;

        const priceEl = this.priceWrapper.querySelector('.f-price');
        const regularEl = this.priceWrapper.querySelector('.f-price__regular .f-price-item--regular');
        const saleEl = this.priceWrapper.querySelector('.f-price__sale .f-price-item--sale');
        const compareEl = this.priceWrapper.querySelector('.f-price__sale .f-price-item--regular s');

        priceEl && priceEl.classList.toggle('f-price--on-sale', onSale);
        priceEl && priceEl.classList.toggle('f-price--sold-out', option.hasAttribute('disabled'));

        if (regularEl) regularEl.innerHTML = onSale ? '' : FoxTheme.Currency.formatMoney(price, format);
        if (saleEl) saleEl.innerHTML = onSale ? FoxTheme.Currency.formatMoney(price, format) : '';
        if (compareEl) compareEl.innerHTML = onSale ? FoxTheme.Currency.formatMoney(compareAtPrice, format) : '';
      }
    }
  );
}
